<template lang="pug">
.product-stat.d-flex.flex-column.h-100.scrollable
  .custom-header.d-flex.sticky-top
    //- CustomTab.flex-fill(
    //-   :tabItems='tabItems'
    //-   v-model='selectedTab'
    //- )
    button.transparent-button.no-scaling.ml-auto.mb-auto(@click='$emit(`closeButtonClicked`)')
      i.fa.fa-times(style='font-size: 24px; padding: 12px 16px;')

  .d-flex.px-4.py-2.mx-3.mb-3
    .d-flex
      img.img-72.rounded-circle(src='http://placekitten.com/200/200')
      div.ml-4
        .text-medium
          | รหัสสินค้า:
          | {{ product.productId }}
        .text-title
          | {{ product.productName }}
    .ml-auto
      .text-medium
        | ยอดขาย
        |
        template(v-if='filterDate && filterDate.from && filterDate.to')
          | {{ $moment(filterDate.from).format('DD MMM YYYY') }}
          | -
          | {{ $moment(filterDate.to).format('DD MMM YYYY') }}
        template(v-else)
          | ...
      .text-xlarge.bold.text-right
        | {{ product.total | currency }}

  hr.m-0

  LoadedContentWrapper.flex-fill(
    :isLoading='isLoading'
    :data='tableData'
    @reload='loadData'
  )
    .py-2.px-3.flex-fill.h-scrollable
      CustomTable(
        :columns='tableColumns'
        :data='filteredTableData'
        :showIndexes='true'
        :itemClickable='false'
      )
    //- @itemClicked='showModal'

    .sticky-bottom.bg-white
      hr.m-0
      .px-4.py-3
        CustomPagination(
          v-model='currentPage'
          :total='totalPage'
        )

</template>

<script>
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';

export default {
  props: {
    customer: {
      default: () => ({}),
    },
    product: {
      default: () => {},
    },
    filterDate: {
      default() {
        return {
          from: this.$moment().toDate(),
          to: this.$moment().toDate(),
        };
      },
    },
    ranking: {
      default: '0',
    },
  },
  // computed: {
  //   formattedDate() {
  //     return this.$moment(this.backOrder.date).format('D MMMM YYYY');
  //   },
  //   formattedTime() {
  //     return this.$moment(this.backOrder.time).format('HH:mm');
  //   },
  // },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.trim().toUpperCase();

      /* eslint-disable-next-line */
      return this.tableData.filter((item) => {
        return (
          (this.filterDate === '' || this.$dateUtils.isInRange(item.date, this.filterDate))
          // && (!this.filterStatus || item.status === this.filterStatus)
          // && (!KEYWORD || item.entryNo.toUpperCase().includes(KEYWORD))
        );
      });
    },
  },
  data: () => ({
    isLoading: false,

    // filterDate: '',
    // filterSearch: '',
    // filterStatus: undefined,

    tableData: [],
    tableColumns: {
      date: {
        title: 'วันที่ทำรายการ',
        align: 'left',
        type: Date,
      },
      productId: {
        title: 'รหัสสินค้า',
      },
      productName: {
        title: 'ชื่อสินค้า',
        align: 'left',
      },
      amount: {
        title: 'จำนวนสินค้า',
        align: 'right',
      },
      price: {
        title: 'ราคาขาย',
        align: 'right',
        type: Number,
        computed: row => row.price / row.amount,
      },
      total: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
        computed: row => row.price,
      },
    },

    // pagination
    currentPage: 1,
    totalPage: 0,
    totalRows: 0,
    pageFirstRowIndex: 1,

    selectedItem: {},
  }),
  methods: {
    async loadData() {
      if (this.product && this.customer) {
        this.isLoading = true;

        // reset data
        this.tableData = null;

        try {
          const res = await this.$api.product.productStat(
            this.product.productId,
            this.customer.id,
            this.filterDate.from,
            this.filterDate.to,
            this.currentPage,
          );
          if (res.status === 200) {
            this.tableData = res.data.data;
            this.currentPage = res.data.current_page;
            this.totalPage = res.data.last_page;
            this.totalRows = res.data.total;
            this.pageFirstRowIndex = res.data.from;
          }
        } catch (e) {
          this.tableData = null;
          this.pageFirstRowIndex = 1;
        }

        this.isLoading = false;
      }
    },
  },
  mounted() {
    // const id = this.customer ? this.customer.id : '';
    if (this.customer) {
      this.loadData();
    }
  },
  components: {
    CustomerCompactDetailHeader,
  },
};
</script>

<style lang="scss">
// .product-stat {}
.custom-header {
  background: #fff;
  // padding-bottom: 8px;
}
</style>
